"use client";

import { REGEXP_ONLY_DIGITS } from "input-otp";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { Typography } from "@/components/Typography";
import { Button } from "@/components/ui/button";

type OtpContentProps = {
  otpResetKey?: number;
  otpValue: string;
  onOtpChange: (value: string) => void;
  onSubmit: (event?: React.BaseSyntheticEvent) => void;
  resendCountdown: number;
  onResendClick?: () => void;
  isSubmitting?: boolean;
  isResending?: boolean;
  errorMessage?: string;
};

const OtpContent = ({
  otpResetKey = 0,
  otpValue,
  onOtpChange,
  onSubmit,
  resendCountdown,
  onResendClick,
  isSubmitting,
  isResending,
  errorMessage,
}: OtpContentProps) => {
  const isComplete = otpValue.length === 6;
  const minutes = String(Math.floor(resendCountdown / 60)).padStart(2, "0");
  const seconds = String(resendCountdown % 60).padStart(2, "0");

  return (
    <div className="flex w-full flex-col px-4 md:pb-0 pb-10">
      <form onSubmit={onSubmit} className="flex flex-col gap-4 pt-1">
        <InputOTP
          key={otpResetKey}
          maxLength={6}
          pattern={REGEXP_ONLY_DIGITS}
          value={otpValue}
          onChange={onOtpChange}
          containerClassName="justify-center"
          autoFocus
          isError={Boolean(errorMessage)}
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
            <InputOTPSlot index={3} />
            <InputOTPSlot index={4} />
            <InputOTPSlot index={5} />
          </InputOTPGroup>
        </InputOTP>

        {errorMessage ? (
          <Typography variant="body2" className="text-center !text-error-foreground">
            {errorMessage}
          </Typography>
        ) : null}

        <Button
          size="xl"
          type="submit"
          disabled={!isComplete || isSubmitting}
          isLoading={isSubmitting}
        >
          Verify
        </Button>
      </form>

      {resendCountdown <= 0 ? (
        <div className="flex items-center justify-center gap-1 pt-2">
          <Typography variant="body2" className="text-caption">
            Didn&apos;t receive the code?
          </Typography>
          <Button
            variant="link"
            onClick={onResendClick}
            isLoading={isResending}
            loadingText="Sending..."
            className="text-secondary px-0 h-auto font-semibold"
          >
            Resend
          </Button>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-1 pt-2">
          <Typography variant="body2" className="text-caption">
            Resend code in{" "}
          </Typography>
          <Typography variant="body2" className="font-bold">
            {minutes}:{seconds}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default OtpContent;
